'use client';

import { updateComplianceConsents } from '@/api/account';
import { getStoreState } from '@/store';

type MeasurementComplianceConsentInput = {
  sceneCode: string;
  page: string;
  metadata: Record<string, unknown>;
};

type CompliancePolicy = {
  consent_type: number;
  id?: string | number;
  policy_id?: string | number;
  policy_version: string | number;
};

type ComplianceScene = {
  policies?: CompliancePolicy[];
};

/**
 * 使用 global init 下发的场景协议项上报在线测量协议同意。
 */
export async function reportMeasurementComplianceConsent({
  sceneCode,
  page,
  metadata,
}: MeasurementComplianceConsentInput) {
  const scene = getStoreState().compliancePolicies?.[sceneCode] as ComplianceScene | undefined;
  const policies = scene?.policies ?? [];
  if (!policies.length) return;

  const items = policies.flatMap(({ consent_type, id, policy_id, policy_version }) => {
    const resolvedPolicyId = id ?? policy_id;
    if (resolvedPolicyId == null) return [];

    return [
      {
        consent_type,
        policy_id: resolvedPolicyId,
        policy_version,
        status: 1,
        metadata,
      },
    ];
  });
  if (!items.length) return;

  await updateComplianceConsents({
    scene_code: sceneCode,
    page,
    items,
  });
}
